import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, takeUntil } from 'rxjs';
import { DepartmentsService } from 'src/app/admin/data/services/departments.service';
import { TokenStorageService } from 'src/app/core/service/token-storage.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { FamilyDetailsComponent } from '../../family/family-details/family-details.component';
import { AccountService } from '../../users/data/services/account.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { HttpParams } from '@angular/common/http';
import Swal from 'sweetalert2';
import { AccountDetailsComponent } from '../../users/pages/account-details/account-details.component';

@Component({
  selector: 'app-family-members',
  templateUrl: './family-members.component.html',
  styleUrls: ['./family-members.component.sass']
})
export class FamilyMembersComponent extends BaseComponent implements OnInit {
  submitted = false;
  loading = false;
  error = "";
  users: any[] = [];
  hide = true;
  subscription: any;
  displayedColumns: string[] = [

    "id",
    "member",
    "number", "role",


  ];

  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  contextMenu: MatMenuTrigger;

  selection = new SelectionModel<any>(false, []);

  familyDetails: any;
  selectedRows: any[] = [];
  atleastOneSelected: boolean = false;

  dataSourceFilteredList: any[] = [];
  familyArray: any[] = [];

  destroy$: Subject<boolean> = new Subject<boolean>();

  isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<FamilyDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private snackbar: SnackbarService,
    private communityService: DepartmentsService,
    private accountService: AccountService,
    private tokenStorage: TokenStorageService

  ) {
    super();
  }

  ngOnInit(): void {


    this.getData(this.data.familyId);
    this.getAllUsers();
  }
  ngAfterViewInit() {




  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  filter() {
    //let storeId = [1, 2, 3];
    this.dataSource.data.forEach((element) => {
      this.familyArray.forEach((item) => {
        if (item === element.id) {
          // this.dataSourceFilteredList.push(this.dataSource.data.indexOf(element));
          this.selection.select(element);
        }
      });
    });

    console.log("dataSourceFilteredList ", this.dataSourceFilteredList);
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  //******************************************************************************************************
  //Select expense

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1
      }`;
  }

  expSelected() {
    this.atleastOneSelected = true;
    this.selectedRows = this.selection.selected;

    console.log("this.selectedRows: ", this.selectedRows);
  }
  proceed() {
    this.dialogRef.close({ event: "close", data: this.selectedRows });

    //   console.log(data);
  }

  onNoClick(): void {
    this.dialogRef.close({ event: "close", data: this.selectedRows });
  }
  public confirmAdd(): void { }

  detailsCall(user) {
    console.log(user);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "500px";
    dialogConfig.data = {

      number: user.memberNumber, // Pass the selected user's data
      action: "details",
    };

    const dialogRef = this.dialog.open(AccountDetailsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      this.getAllUsers();
    });
  }

  getAllUsers() {
    var parishId = this.tokenStorage.getUser().parishId;

    this.accountService
      .members(parishId)
      .pipe(takeUntil(this.subject))
      .subscribe(
        (res) => {
          this.users = res;

          if (this.users) {
            this.isLoading = false;
          }


        },
        (err) => {
          console.log(err);
        }
      );
  }

  getData(familyId: any) {
    const params = new HttpParams()
      .set("id", this.data.familyId)

    this.accountService.getFamilyById(familyId).subscribe(
      (res) => {
        let members = res.members;

        if (res) {
          this.familyArray = res;

        } else {

        }


        this.dataSource = new MatTableDataSource<any>(members);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.isLoading = false;


      },
      (error) => {

      }
    );
  }

  generateReportDynamically(familyId: any) {
    const params = new HttpParams()
      .set("id", familyId)
    this.loading = true;
    this.subscription = this.accountService
      .loadFamily(familyId)
      .subscribe(
        (response) => {
          console.log("Received data");
          console.log(response.data);
          let url = window.URL.createObjectURL(response.data);
          console.log(url);

          window.open(url);

          this.loading = false;


          Swal.fire({
            icon: 'success',
            title: 'Family Member Report',
            text: ' Report Successfully Downloaded',
            confirmButtonText: 'OK'
          });
        },
        (err) => {
          this.error = err;
          this.loading = false;


          Swal.fire({
            icon: 'error',
            title: 'Family Member Report',
            text: 'Report Failed to Download',
            confirmButtonText: 'OK'
          });
        }
      );
  }



}
